import { useSelector } from 'react-redux'
import { isAnonymousUserSelector } from '../selectors'

export function useIsAnonymousUser() {
  return useSelector(isAnonymousUserSelector)
}
